<template>
  <div class="team-table-container native-table-wrap">
    <table class="native-table">
      <thead>
        <tr><th>团队名称</th><th>团队介绍</th><th>优势特点</th><th>照片数量</th><th>操作</th></tr>
      </thead>
      <tbody>
        <tr v-for="row in teamList" :key="row.id">
          <td>{{ row.name }}</td>
          <td class="truncate" :title="row.description">{{ row.description }}</td>
          <td>
            <template v-if="row.advantages?.length">
              {{ row.advantages.slice(0, 3).map((item) => item.advantage).join("、") }}
              <span v-if="row.advantages.length > 3"> +{{ row.advantages.length - 3 }}</span>
            </template>
            <span v-else>暂无</span>
          </td>
          <td>{{ row.photographs?.length || 0 }} 张</td>
          <td class="actions">
            <NativeButton type="primary" size="small" @click="emit('edit', row)">编辑</NativeButton>
            <NativeButton type="danger" size="small" @click="emit('delete', row)">删除</NativeButton>
          </td>
        </tr>
        <tr v-if="teamList.length === 0"><td colspan="5" class="empty-cell">暂无数据</td></tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts" setup>
import type { TeamType } from "@/stores/teams";

defineProps<{ teamList: TeamType[] }>();
const emit = defineEmits<{
  (event: "edit", row: TeamType): void;
  (event: "delete", row: TeamType): void;
}>();
</script>

<style scoped lang="scss">
.team-table-container { height: 100%; }
.native-table { width: 100%; border-collapse: collapse; font-size: 0.9rem; }
th, td { padding: 10px 12px; border: 1px solid #e2e8f0; text-align: left; vertical-align: top; }
th { position: sticky; top: 0; background: #f8fafc; color: #334155; white-space: nowrap; }
tbody tr:nth-child(even) { background: #fafafa; }
.truncate { max-width: 280px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.actions { display: flex; gap: 6px; }
.empty-cell { padding: 30px; color: #64748b; text-align: center; }
</style>
